import { get, find, orderBy } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getReservationAvailableEvents = get('reservation.availableEvents');

export const getAll = createSelector(getReservationAvailableEvents, get('all'));

export const getOrderedEvents = createSelector(
  getAll,
  orderBy(['date', 'startTime'], ['asc', 'asc'])
);

export const getEventForId = createSelector((_, id) => ({ id }), getAll, find);

export const getMeta = createSelector(
  getReservationAvailableEvents,
  get('meta')
);

export const getIsFetching = createSelector(
  getReservationAvailableEvents,
  get('fetching')
);
export const getIsFetched = createSelector(
  getReservationAvailableEvents,
  get('fetched')
);

export const getFetchingError = createSelector(
  getReservationAvailableEvents,
  get('fetchingError')
);
